/* eslint-disable */
import axios from 'axios'
import Qs from 'qs'
import Vue from 'vue'
import Router from '@/router'
import { Toast } from 'vant'

Vue.use(Toast)
axios.defaults.baseURL = '/api'

// 设置请求超时时间
axios.defaults.timeout = 90000

// axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  config => {
    // 判断数据类型切换头部默认是json
    if (config.commitType) {
      if (config.commitType === 'form') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.transformRequest = [
          function(data) {
            return Qs.stringify(data) // 利用对应方法转换格式
          },
        ]
      }
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    Toast('请求超时')
    return Promise.error(error)
  }
)

// 响应拦截
axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response
  },
  error => {
    const { status, data } = error.response
    return Promise.reject(error)
  }
  // 对响应错误做点什么
)

// 封装get方法和post方法

// 处理返回数据
const successFn = (fn, res, reject) => {
  if (res.data.meta.code === 0) {
    fn(res.data)
  }
  else {
    if (res.data.meta.message) {
      Toast(res.data.meta.message)
    }
    reject(res.data)
  }
}

const errFn = (fn, res) => {
  // if (res && res.data && res.data.msg) {
  //   Toast(res.data.msg);
  // }
  fn(res && res.data)
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params,
      })
      .then(res => {
        successFn(resolve, res, reject)
      })
      .catch(err => {
        errFn(reject, err)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params,config) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params,config)
      .then(res => {
        successFn(resolve, res, reject)
      })
      .catch(err => {
        if(axios.isCancel(err)){
          console.log('cancel request')
        }
        errFn(reject, err)
      })
  })
}

